module.exports = __webpack_public_path__ + "media/images/athletes/1473-2a46deaf74da43aa5f9a73d5e6b01816.png";